import React, { Fragment } from "react";
import { observer } from "mobx-react";
import { http } from "../../services/HttpInterceptor";
import { RouteComponentProps, Link, Redirect } from "react-router-dom";
import { toast } from "react-toastify";
import { observable } from "mobx";
import { formatRelative } from "date-fns";
import { es } from "date-fns/locale";
import { apiUrl } from "../../services/HttpInterceptorUtil";
import swal from "sweetalert";
import { createBrowserHistory } from "history";
import { sessionService } from "../../services/SessionService";
import { EditionHistory } from "./sub-components/EditionHistory";
import { Photos } from "./sub-components/Photos";
import { ContractActionButton } from "./sub-components/ContractActionButton";
import { ContractLinkButton } from "./sub-components/ContractLinkButton";
import { ContractConditionalBlock } from "./sub-components/ContractConditionalBlock";

interface ViewContractProps extends RouteComponentProps {
  changeToggle(action?: boolean): void;
}

const history = createBrowserHistory({ forceRefresh: true });

@observer
export default class ViewContract extends React.Component<ViewContractProps> {
  @observable private contract: any;
  @observable private isLoaded = false;
  @observable private contract_invoices: any;
  @observable private support_tickets: any;
  @observable private inventory_items: any;
  @observable private payments: any;
  @observable private photos: any;
  @observable private redirect: boolean = false;
  @observable private editionHistory: any;
  @observable private installments: any;
  @observable private testingConnection = false;
  @observable private lastConnectionMessage: string = "";
  @observable private testConnectionResult: any = null;
  private testConnectionRequestId = 0;
  @observable private updatingMoroso = false;
  @observable private morosoHintVisible = false;
  @observable private web_name: string = (() => {
    if (process.env.NODE_ENV === "development") {
      return "develop";
    }

    const url = process.env.REACT_APP_URL;

    switch (url) {
      case "https://sur.serviciosinalambricos.com.mx":
      case "https://sur-2.serviciosinalambricos.com.mx":
      case "https://servicios-sur.web.app":
        return "sur";
      case "https://norte.serviciosinalambricos.com.mx":
      case "https://norte-2.serviciosinalambricos.com.mx":
        return "norte";
      case "https://wirserv.serviciosinalambricos.com.mx":
      case "https://wirserv-2.serviciosinalambricos.com.mx":
        return "wirserv";
      case "https://develop.serviciosinalambricos.com.mx":
        return "develop";
      default:
        console.warn(`Unexpected REACT_APP_URL in production: ${url}`);
        return ""; // Or return a default like "norte", null, etc.
    }
  })();

  componentDidMount() {
    this.props.changeToggle(true);
    this.init();
  }

  init = () => {
    const match = this.props.match;
    const id = (match as any).params.id.replace("W", "");
    let idW = (match as any).params.id;
    if (this.web_name === "wirserv") {
      if (!idW.startsWith("W")) {
        idW = "W" + idW;
      }
    }
    http
      .get(`/api/contract/read/${idW}`)
      .then((response) => {
        let data = response.data;
        if (
          data &&
          typeof data === "object" &&
          !Array.isArray(data) &&
          data.response &&
          typeof data.response === "object" &&
          !Array.isArray(data.response) &&
          data.client_name == null &&
          data.status == null
        ) {
          data = data.response;
        }
        if (
          !data ||
          typeof data !== "object" ||
          Array.isArray(data) ||
          (data.status == null &&
            data.client_name == null &&
            data.ip == null &&
            data.address_street == null)
        ) {
          throw new Error("Error cargando contrato");
        }
        this.contract = data;
        if (this.contract.id == null || this.contract.id === "") {
          this.contract.id = (this.props.match as any).params.id;
        }
      })
      .then(() => {
        return http.get(`/api/invoice/contract/${id}`).then((response) => {
          this.contract_invoices = response.data;
        });
      })
      .then(() => {
        return http.get(`/api/payment/contract/${id}`).then((response) => {
          this.payments = response.data;
        });
      })
      .then(() => {
        return http.get(`/api/support/contract/${id}`).then((response) => {
          this.support_tickets = response.data.response;
        });
      })
      .then(() => {
        return http
          .get(`/api/inventory/checkitems/${id}/CONTRACT`)
          .then((response) => {
            this.inventory_items = response.data.response;
          });
      })
      .then(() => {
        return http.get(`/api/contract/installment/${id}`).then((response) => {
          this.installments = response.data;
        });
      })
      .then(() => {
        this.isLoaded = true;
      })
      .catch((error) => {
        toast.error("Error cargando contrato");
      });
  };

  removeDisconnect = () => {
    swal({
      title: "Confirmar acción",
      text: "¿Esto eliminara el cargo de reconexion y modificara recibos activos?",
      icon: "warning",
      dangerMode: true,
    }).then((willSave) => {
      if (willSave) {
        const obj = JSON.stringify({
          id: this.contract.id != null && this.contract.id.toString().startsWith("W")
            ? this.contract.id.substring(1)
            : this.contract.id,
          updated_by: sessionService.getUserInfo().id,
        });
        http.post("/api/invoice/disconnection", obj).then(() => {
          toast.success("Se quito el cargo de reconexion");
        });
      }
    });
  };

  onPay = () => {
    history.push(
      `/pagos/adicional/${
        this.contract.id != null && this.contract.id.toString().startsWith("W")
          ? this.contract.id.substring(1)
          : this.contract.id
      }`
    );
  };

  private getContractNumericId = (): string | number => {
    const id = this.contract && this.contract.id;
    if (id == null) {
      return id;
    }
    const asString = String(id);
    return asString.startsWith("W") ? asString.substring(1) : id;
  };

  private isMikrotikConnected = (): boolean => {
    return Number(this.contract && this.contract.mikrotik_status) === 1;
  };

  private isMikrotikMoroso = (): boolean => {
    return Number(this.contract && this.contract.mikrotik_moroso) === 1;
  };

  private toggleMikrotikMoroso = (): void => {
    if (
      !this.isMikrotikConnected() ||
      this.updatingMoroso ||
      !sessionService.canViewSection("MikroTik.edit")
    ) {
      return;
    }
    this.updatingMoroso = true;
    http
      .post(
        `/api/contract/moroso`,
        JSON.stringify({ id: this.getContractNumericId() })
      )
      .then((response) => {
        this.updatingMoroso = false;
        const payload = this.parseTestConnectionResponse(response.data);
        if (payload && payload.ok === false) {
          toast.error(
            (payload && payload.message) ||
              "No se pudo actualizar el estatus de moroso"
          );
          return;
        }
        const moroso =
          payload && payload.mikrotik_moroso != null
            ? payload.mikrotik_moroso
            : Number(!this.isMikrotikMoroso());
        this.contract = {
          ...this.contract,
          mikrotik_moroso: moroso,
        };
        const message =
          (payload && payload.message) ||
          (Number(moroso) === 1
            ? "Marcado en moroso."
            : "Quitado de moroso.");
        toast.success(message);
      })
      .catch((error) => {
        this.updatingMoroso = false;
        const payload =
          error && error.response && error.response.data
            ? this.parseTestConnectionResponse(error.response.data)
            : null;
        const msg =
          (payload && payload.message) ||
          (error && error.message) ||
          "No se pudo actualizar el estatus de moroso";
        toast.error(String(msg));
      });
  };

  private testConnection = (): void => {
    const requestId = ++this.testConnectionRequestId;
    this.testingConnection = true;
    this.lastConnectionMessage = "";
    this.testConnectionResult = null;
    http
      .post(
        `/api/contract/test_connection`,
        JSON.stringify({ id: this.getContractNumericId() })
      )
      .then((response) => {
        if (requestId !== this.testConnectionRequestId) {
          return;
        }
        this.testingConnection = false;
        const payload = this.parseTestConnectionResponse(response.data);
        this.applyTestConnectionPayload(payload);
      })
      .catch((error) => {
        if (requestId !== this.testConnectionRequestId) {
          return;
        }
        this.testingConnection = false;
        this.testConnectionResult = null;
        this.contract = { ...this.contract, mikrotik_status: 0 };
        const raw =
          error && error.response && error.response.data
            ? error.response.data
            : error;
        const payload = this.parseTestConnectionResponse(raw);
        const message = this.formatContractConnectionMessage(
          payload && typeof payload === "object"
            ? payload
            : { message: error && error.message ? error.message : error }
        );
        this.lastConnectionMessage = message;
        toast.error(message);
      });
  };

  /** Respuesta de test_connection: { ok, message, mikrotik_status, data?, ... }. HTTP 200 no implica éxito. */
  private parseTestConnectionResponse(raw: any): any {
    if (raw == null) {
      return null;
    }
    if (
      typeof raw === "object" &&
      ("ok" in raw || "mikrotik_status" in raw || "mikrotik_moroso" in raw)
    ) {
      return raw;
    }
    if (typeof raw === "object" && raw.response != null) {
      const inner = raw.response;
      if (
        typeof inner === "object" &&
        ("ok" in inner ||
          "mikrotik_status" in inner ||
          "mikrotik_moroso" in inner)
      ) {
        return inner;
      }
    }
    return raw;
  }

  private isContractConnectionOk(payload: any): boolean {
    if (payload == null || typeof payload !== "object") {
      return false;
    }
    if (payload.mikrotik_status != null) {
      return Number(payload.mikrotik_status) === 1;
    }
    const ok = payload.ok;
    return ok === true || ok === 1 || ok === "true" || ok === "1";
  }

  private applyTestConnectionPayload = (payload: any): void => {
    const connected = this.isContractConnectionOk(payload);
    const message = this.formatContractConnectionMessage(payload);

    if (connected) {
      const contractPatch =
        payload && payload.contract && typeof payload.contract === "object"
          ? payload.contract
          : {};
      this.contract = {
        ...this.contract,
        ...contractPatch,
        id: this.contract.id,
        mikrotik_status:
          payload && payload.mikrotik_status != null
            ? payload.mikrotik_status
            : 1,
      };
      this.testConnectionResult = payload;
      this.lastConnectionMessage = message;
      toast.success(message);
      return;
    }

    this.contract = { ...this.contract, mikrotik_status: 0 };
    this.testConnectionResult = null;
    this.lastConnectionMessage = message;
    toast.error(message);
  };

  private formatContractConnectionMessage(payload: any): string {
    if (payload == null) {
      return "No se pudo probar la conexión del contrato.";
    }
    let msg = payload.message || payload.error || "";
    if (typeof msg !== "string") {
      msg = String(msg);
    }
    const lower = msg.toLowerCase();
    if (lower.includes("no tiene ip") || lower.includes("ip asignada")) {
      return "Falta IP en el contrato";
    }
    if (lower.includes("no aparece en arp")) {
      return "Cliente apagado o fuera de red";
    }
    if (lower.includes("no hay routers")) {
      return "No hay routers dados de alta";
    }
    if (
      lower.includes("usuario o contraseña") ||
      lower.includes("contraseña incorrect")
    ) {
      return "Credenciales del router";
    }
    if (msg) {
      return msg;
    }
    return this.isContractConnectionOk(payload)
      ? "Conexión correcta: la IP está en la red."
      : "No se pudo probar la conexión del contrato.";
  }

  loadPhotos = () => {
    http.get(`/api/contract/images/${this.contract.id}`).then((response) => {
      this.photos = response.data;
    });
  };

  loadHistory = () => {
    http
      .get(
        `/api/contract/history/${
          this.contract.id != null && this.contract.id.toString().startsWith("W")
            ? this.contract.id.substring(1)
            : this.contract.id
        }`
      )
      .then((response) => {
        this.editionHistory = response.data.response;
      });
  };

  onSupport = () => {
    history.push(
      `/soporte/${
        this.contract.id != null && this.contract.id.toString().startsWith("W")
          ? this.contract.id.substring(1)
          : this.contract.id
      }/nuevo`
    );
  };

  onAddBalance = () => {
    history.push(
      `/pagos/afavor/${
        this.contract.id != null && this.contract.id.toString().startsWith("W")
          ? this.contract.id.substring(1)
          : this.contract.id
      }`
    );
  };

  onAddNegativeBalance = () => {
    history.push(`/contratos/negativo/${this.contract.id}`);
  };

  onAddInvoivce = () => {
    history.push(
      `/recibos/crear/${
        this.contract.id != null && this.contract.id.toString().startsWith("W")
          ? this.contract.id.substring(1)
          : this.contract.id
      }`
    );
  };

  onInstallments = () => {
    history.push(`/contratos/plazos/${this.contract.id}`);
  };

  render() {
    if (this.redirect) {
      return <Redirect to="/contratos" />;
    }

    if (!this.isLoaded) {
      return null;
    }
    return (
      <Fragment>
        <div className="row">
          <div className="col-md-8">
            <div className="card">
              <div className="card-header card-header-rose card-header-text">
                <div className="card-text">
                  <h4 className="card-title">Contrato #{this.contract.id}</h4>
                </div>
              </div>
              <div className="card-body ">
                <div className="row">
                  <div className="col-sm-8"></div>
                  <div className="col-sm-2">
                    {sessionService.canViewSection("Contratos.edit") && (
                      <Link to={`../../contratos/edit/${this.contract.id}`}>
                        <button className="btn btn-success btn-sm  pull-right">
                          <i className="material-icons">edit</i>
                          <div className="ripple-container"></div>
                        </button>
                      </Link>
                    )}
                  </div>
                  <div className="col-sm-2">
                    <Link to={`../../contratos`}>
                      <button className="btn btn-danger btn-sm  pull-right">
                        <i className="material-icons">highlight_off</i>
                        <div className="ripple-container"></div>
                      </button>
                    </Link>
                  </div>
                </div>
                <div className="row">
                  <label className="col-sm-4">Cliente</label>
                  <div className="col-sm-8">
                    <strong>{this.contract.client_name}</strong>
                  </div>
                </div>
                <div className="row">
                  <label className="col-sm-4">Telefono Cliente</label>
                  <div className="col-sm-8">
                    <strong>{this.contract.client_phone}</strong>
                  </div>
                </div>
                <div className="row">
                  <label className="col-sm-4">Otros Telefonos</label>
                  <div className="col-sm-8">
                    <strong>{this.contract.other_phones}</strong>
                  </div>
                </div>
                <div className="row">
                  <label className="col-sm-4">Referencia</label>
                  <div className="col-sm-8">
                    <strong>{this.contract.reference}</strong>
                  </div>
                </div>
                <div className="row">
                  <label className="col-sm-4">Teléfono de Referencia</label>
                  <div className="col-sm-8">
                    <strong>{this.contract.reference_phone}</strong>
                  </div>
                </div>
                <div className="row">
                  <label className="col-sm-4">Relación de Referencia</label>
                  <div className="col-sm-8">
                    <strong>{this.contract.reference_relationship}</strong>
                  </div>
                </div>
                <div className="row">
                  <label className="col-sm-4">Dirección</label>
                  <div className="col-sm-8">
                    <strong>{this.contract.address_street}</strong>
                  </div>
                </div>
                <div className="row">
                  <label className="col-sm-4">Colonia</label>
                  <div className="col-sm-8">
                    <strong>{this.contract.address_colonia}</strong>
                  </div>
                </div>
                <div className="row">
                  <label className="col-sm-4">Número Interior</label>
                  <div className="col-sm-8">
                    <strong>{this.contract.address_interior}</strong>
                  </div>
                </div>
                <div className="row">
                  <label className="col-sm-4">Número Exterior</label>
                  <div className="col-sm-8">
                    <strong>{this.contract.address_exterior}</strong>
                  </div>
                </div>
                <div className="row">
                  <label className="col-sm-4">Codigo Postal</label>
                  <div className="col-sm-8">
                    <strong>{this.contract.address_zipcode}</strong>
                  </div>
                </div>
                <div className="row">
                  <label className="col-sm-4">Referencia de dirección</label>
                  <div className="col-sm-8">
                    <strong>{this.contract.address_reference}</strong>
                  </div>
                </div>
                <div className="row">
                  <label className="col-sm-4">Fecha de corte</label>
                  <div className="col-sm-8">
                    <strong>{this.contract.cutoff_date}</strong>
                  </div>
                </div>
                <div className="row">
                  <label className="col-sm-4">Tipo de casa</label>
                  <div className="col-sm-8">
                    <strong>{this.contract.house_type}</strong>
                  </div>
                </div>
                <div className="row">
                  <label className="col-sm-4">Paquete contratado</label>
                  <div className="col-sm-8">
                    <strong>{this.contract.package_name}</strong>
                  </div>
                </div>
                <div className="row">
                  <label className="col-sm-4">Forma de cobro</label>
                  <div className="col-sm-8">
                    <strong>{this.contract.payment_type}</strong>
                  </div>
                </div>
                {this.contract.sectorial_name && (
                  <div className="row">
                    <label className="col-sm-4">Sectorial</label>
                    <div className="col-sm-8">
                      <strong>{this.contract.sectorial_name}</strong>
                    </div>
                  </div>
                )}
                {this.contract.mac && (
                  <div className="row">
                    <label className="col-sm-4">MAC </label>
                    <div className="col-sm-8">
                      <strong>{this.contract.mac}</strong>
                    </div>
                  </div>
                )}
                <div className="row">
                  <label className="col-sm-4">IP</label>
                  <div className="col-sm-8">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                      }}
                    >
                      {this.contract.ip ? (
                        <h3 style={{ margin: "0 12px 0 0" }}>
                          {this.contract.ip}
                        </h3>
                      ) : (
                        <strong style={{ marginRight: 12 }}>—</strong>
                      )}
                      {sessionService.canViewSection("MikroTik.view") &&
                        (this.isMikrotikConnected() ? (
                          <span
                            className="badge badge-success"
                            style={{ fontSize: "0.85rem", marginRight: 12 }}
                          >
                            En red
                          </span>
                        ) : (
                          <span
                            className="badge badge-secondary"
                            style={{ fontSize: "0.85rem", marginRight: 12 }}
                          >
                            Sin conexión
                          </span>
                        ))}
                      {sessionService.canViewSection("MikroTik.view") && (
                        <button
                          onClick={this.testConnection}
                          type="button"
                          className="btn btn-info btn-sm"
                          disabled={this.testingConnection}
                          style={{ margin: 0 }}
                        >
                          {this.testingConnection
                            ? "Probando..."
                            : "Probar conexión"}
                        </button>
                      )}
                      {sessionService.canViewSection("MikroTik.view") && (
                        <span
                          onMouseEnter={() => {
                            this.morosoHintVisible = !this.isMikrotikConnected();
                          }}
                          onMouseLeave={() => {
                            this.morosoHintVisible = false;
                          }}
                          style={{
                            display: "inline-block",
                            marginLeft: 8,
                            position: "relative",
                          }}
                        >
                          <button
                            onClick={this.toggleMikrotikMoroso}
                            type="button"
                            className={
                              this.isMikrotikMoroso()
                                ? "btn btn-success btn-sm"
                                : "btn btn-danger btn-sm"
                            }
                            disabled={
                              !this.isMikrotikConnected() ||
                              this.updatingMoroso ||
                              !sessionService.canViewSection("MikroTik.edit")
                            }
                            style={{ margin: 0 }}
                          >
                            {this.updatingMoroso
                              ? "Guardando..."
                              : this.isMikrotikMoroso()
                              ? "Sacar de morosos"
                              : "Desconectar MikroTik"}
                          </button>
                          {this.morosoHintVisible && (
                            <span
                              style={{
                                position: "absolute",
                                left: 0,
                                top: "100%",
                                marginTop: 4,
                                background: "#323232",
                                color: "#fff",
                                fontSize: "12px",
                                lineHeight: 1.3,
                                padding: "6px 8px",
                                borderRadius: 4,
                                whiteSpace: "nowrap",
                                zIndex: 20,
                                boxShadow: "0 2px 6px rgba(0,0,0,.25)",
                              }}
                            >
                              Prueba antes la conexión
                            </span>
                          )}
                        </span>
                      )}
                    </div>
                    {sessionService.canViewSection("MikroTik.view") &&
                      this.lastConnectionMessage && (
                      <p
                        className={
                          this.isMikrotikConnected()
                            ? "text-success"
                            : "text-danger"
                        }
                        style={{ marginTop: 8, marginBottom: 0 }}
                      >
                        {this.lastConnectionMessage}
                      </p>
                    )}
                    {sessionService.canViewSection("MikroTik.view") &&
                      this.testConnectionResult &&
                      this.isMikrotikConnected() &&
                      this.testConnectionResult.router && (
                        <div style={{ marginTop: 8 }}>
                          <strong>Router:</strong>{" "}
                          {this.testConnectionResult.router.name ||
                            this.testConnectionResult.router.ip}
                        </div>
                      )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card">
              <div className="card-body ">
                <div className="row">
                  <div className="col-sm-12" style={{ textAlign: "center" }}>
                    {this.contract.status !== "Cerrado" && (
                      <Fragment>
                        <ContractActionButton
                          condition={
                            sessionService.canViewSection(
                              "Contratos.disconnect_charge"
                            ) && this.contract.disconnect_charge === 1
                          }
                          onClick={this.removeDisconnect}
                          className="btn-danger"
                          label="Quitar cargo de reconexion"
                        />

                        <ContractActionButton
                          condition={sessionService.canViewSection(
                            "Contratos.balance"
                          )}
                          onClick={this.onAddBalance}
                          className="btn-info"
                          label="Agregar saldo a favor"
                        />

                        <ContractActionButton
                          condition={sessionService.canViewSection(
                            "Contratos.debitbalance"
                          )}
                          onClick={this.onAddNegativeBalance}
                          className="btn-danger"
                          label="Fijar saldo deudor"
                        />

                        <ContractActionButton
                          condition={sessionService.canViewSection(
                            "Contratos.support"
                          )}
                          onClick={this.onSupport}
                          className="btn-warning"
                          label="Crear orden de soporte"
                        />

                        <ContractActionButton
                          condition={sessionService.canViewSection(
                            "Contratos.additional"
                          )}
                          onClick={this.onPay}
                          className="btn-info"
                          label="Pagar recibo adicional"
                        />

                        <ContractActionButton
                          condition={sessionService.canViewSection(
                            "Contratos.addinvoice"
                          )}
                          onClick={this.onAddInvoivce}
                          className="btn-success"
                          label="Crear recibo al contrato"
                        />

                        <ContractLinkButton
                          condition={sessionService.canViewSection(
                            "Contratos.addimages"
                          )}
                          link={`../imagenes/${this.contract.id}`}
                          className="btn-success"
                          label="Agregar imagenes"
                        />

                        <ContractLinkButton
                          condition={sessionService.canViewSection(
                            "Contratos.close"
                          )}
                          link={`../cancelar/${this.contract.id}`}
                          label="Dar de baja contrato"
                          className="btn-danger"
                        />
                      </Fragment>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-body ">
                <div className="row">
                  <div className="col-sm-12" style={{ textAlign: "center" }}>
                    <h3>Saldo a favor</h3>
                    <h2>${this.contract.balance}</h2>
                  </div>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-body ">
                <div className="row">
                  <div className="col-sm-12" style={{ textAlign: "center" }}>
                    <h3>Saldo deudor</h3>
                    <h2>${this.contract.due_balance}</h2>
                    <ContractActionButton
                      condition={sessionService.canViewSection(
                        "Contratos.installments"
                      ) && this.contract.due_balance > 0 && this.installments.id === null}
                      onClick={this.onInstallments}
                      className="btn-danger"
                      label="Diferir saldo deudor a meses"
                    />
                  </div>
                </div>
              </div>
            </div>
            {this.installments && this.installments.id && (
              <div className="card">
                <div className="card-header card-header-info card-header-text">
                  <div className="card-text">
                    <h4 className="card-title">Plan de pagos actual</h4>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-3">
                      <h6>Total del plan:</h6>
                      <p className="text-primary">${this.installments.total}</p>
                    </div>
                    <div className="col-md-3">
                      <h6>Meses a pagar:</h6>
                      <p className="text-primary">{this.installments.num_meses} meses</p>
                    </div>
                    <div className="col-md-3">
                      <h6>Pagos pendientes:</h6>
                      <p className="text-warning">{this.installments.pagos_pendientes} pagos</p>
                    </div>
                    <div className="col-md-3">
                      <h6>Monto mensual:</h6>
                      <p className="text-success">${Math.ceil(this.installments.total / this.installments.num_meses)}</p>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-md-8 col-sm-12">
            <div className="card">
              <div className="card-header card-header-info card-header-icon">
                <div className="card-icon">
                  <i className="material-icons">receipt</i>
                </div>
                <h3 className="card-title">Datos de Facturacion</h3>
              </div>
              <div className="card-body ">
                <div className="row">
                  <label className="col-sm-4">RFC</label>
                  <div className="col-sm-8">
                    <strong>{this.contract.rfc}</strong>
                  </div>
                </div>
                <div className="row">
                  <label className="col-sm-4">Razon Social</label>
                  <div className="col-sm-8">
                    <strong>{this.contract.razon_social}</strong>
                  </div>
                </div>
                <div className="row">
                  <label className="col-sm-4">Regimen Fiscal</label>
                  <div className="col-sm-8">
                    <strong>{this.contract.regimen_fiscal}</strong>
                  </div>
                </div>
                <div className="row">
                  <label className="col-sm-4">Uso De CFDI</label>
                  <div className="col-sm-8">
                    <strong>{this.contract.uso_cfdi}</strong>
                  </div>
                </div>
                <div className="row">
                  <label className="col-sm-4">Calle</label>
                  <div className="col-sm-8">
                    <strong>{this.contract.factura_calle}</strong>
                  </div>
                </div>
                <div className="row">
                  <label className="col-sm-4">Colonia</label>
                  <div className="col-sm-8">
                    <strong>{this.contract.factura_colonia}</strong>
                  </div>
                </div>
                <div className="row">
                  <label className="col-sm-4">Numero Interior</label>
                  <div className="col-sm-8">
                    <strong>{this.contract.factura_interior}</strong>
                  </div>
                </div>
                <div className="row">
                  <label className="col-sm-4">Numero Exterior</label>
                  <div className="col-sm-8">
                    <strong>{this.contract.factura_exterior}</strong>
                  </div>
                </div>
                <div className="row">
                  <label className="col-sm-4">Ciudad</label>
                  <div className="col-sm-8">
                    <strong>{this.contract.factura_ciudad}</strong>
                  </div>
                </div>
                <div className="row">
                  <label className="col-sm-4">Estado</label>
                  <div className="col-sm-8">
                    <strong>{this.contract.factura_estado}</strong>
                  </div>
                </div>
                <div className="row">
                  <label className="col-sm-4">Codigo Postal</label>
                  <div className="col-sm-8">
                    <strong>{this.contract.factura_cp}</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 col-sm-12">
            <div className="card">
              <div className="card-header card-header-info card-header-icon">
                <div className="card-icon">
                  <i className="material-icons">history</i>
                </div>
                <h3 className="card-title">Historial del Contrato</h3>
              </div>
              <div className="card-body ">
                <div className="row">
                  <label className="col-sm-4">Status:</label>
                  <div className="col-sm-8">
                    <h2>{this.contract.status}</h2>
                  </div>
                </div>
                <div className="row">
                  <label className="col-sm-4">Contrato creado el:</label>
                  <div className="col-sm-8">
                    <strong>
                      {this.contract.created_date &&
                      !isNaN(new Date(this.contract.created_date).getTime())
                        ? formatRelative(
                            new Date(this.contract.created_date),
                            new Date(),
                            { locale: es }
                          )
                        : this.contract.created_date || "—"}
                    </strong>
                  </div>
                </div>
                <div className="row">
                  <label className="col-sm-4">Notas de Creacion:</label>
                  <div className="col-sm-8">
                    <strong>{this.contract.notes_creation}</strong>
                  </div>
                </div>
                <div className="row">
                  <label className="col-sm-4">Notas de Conexion:</label>
                  <div className="col-sm-8">
                    <strong>{this.contract.notes_connection}</strong>
                  </div>
                </div>
                <ContractConditionalBlock
                  value={this.contract.installed_by_name}
                  label="Instalado por"
                />
                <ContractConditionalBlock
                  value={this.contract.installation_date}
                  label="Instalado el"
                  isDate={true}
                />
                <ContractConditionalBlock
                  value={this.contract.notes_installation}
                  label="Notas de instalación"
                />
                <ContractConditionalBlock
                  value={this.contract.connected_by_name}
                  label="Conectado por"
                />
                <ContractConditionalBlock
                  value={this.contract.connection_date}
                  label="Conectado el"
                  isDate={true}
                />
                <ContractConditionalBlock
                  value={this.contract.closed_by_name}
                  label="Cerrado por"
                />
                <ContractConditionalBlock
                  value={this.contract.closed_date}
                  label="Cerrado el"
                  isDate={true}
                />
                <ContractConditionalBlock
                  value={this.contract.retired_by}
                  label="Retirado por"
                />
                <ContractConditionalBlock
                  value={this.contract.equipment_retired}
                  label="Equipo Retireado"
                />
                <ContractConditionalBlock
                  value={this.contract.retired_date}
                  label="Fecha Retireado"
                />
              </div>
            </div>
          </div>
          <div className="col-md-6 col-sm-12">
            <div className="card">
              <div className="card-header card-header-info card-header-icon">
                <div className="card-icon">
                  <i className="material-icons">help</i>
                </div>
                <h3 className="card-title">Ordenes de Soporte</h3>
              </div>
              <div className="card-body table-responsive">
                <table className="table table-hover">
                  <thead className="text-warning">
                    <tr>
                      <th>#</th>
                      <th>Status</th>
                      <th>Creado</th>
                      <th>Ver</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.support_tickets &&
                      this.support_tickets.map((support: any, index: any) => {
                        return (
                          <tr key={index}>
                            <td>{support.id}</td>
                            <td>{support.status}</td>
                            <td>{support.created_date}</td>
                            <td className="td-actions">
                              <button
                                type="button"
                                title=""
                                onClick={() => this.goSupport(support.id)}
                                className="btn btn-primary btn-link btn-sm"
                              >
                                <i className="material-icons">visibility</i>
                                <div className="ripple-container"></div>
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-sm-12">
            <div className="card">
              <div className="card-header card-header-success card-header-icon">
                <div className="card-icon">
                  <i className="material-icons">monetization_on</i>
                </div>
                <h3 className="card-title">Historial de Recibos</h3>
              </div>
              <div className="card-body table-responsive">
                <table className="table table-hover">
                  <thead className="text-warning">
                    <tr>
                      <th>#</th>
                      <th>Vence</th>
                      <th>Cantidad</th>
                      <th>Tipo</th>
                      <th>Estatus</th>
                      <th>Recibo</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.contract_invoices &&
                      this.contract_invoices.response.data
                        .filter((invoice: any) => invoice.type !== "Adicional")
                        .map(
                          (invoice: any, index: any) => {
                            return (
                              <tr key={index}>
                                <td>{invoice.id}</td>
                                <td>{invoice.due_date}</td>
                                <td>${invoice.amount}</td>
                                <td>{invoice.type}</td>
                                <td>{invoice.status}</td>
                                <td className="td-actions">
                                  <button
                                    type="button"
                                    title=""
                                    onClick={() => this.viewInvoice(invoice.id)}
                                    className="btn btn-primary btn-link btn-sm"
                                  >
                                    <i className="material-icons">visibility</i>
                                    <div className="ripple-container"></div>
                                  </button>
                                </td>
                              </tr>
                            );
                          }
                        )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-sm-12">
            <div className="card">
              <div className="card-header card-header-success card-header-icon">
                <div className="card-icon">
                  <i className="material-icons">payments</i>
                </div>
                <h3 className="card-title">Historial de Pagos</h3>
              </div>
              <div className="card-body table-responsive">
                <table className="table table-hover">
                  <thead className="text-warning">
                    <tr>
                      <th>#</th>
                      <th>Tipo</th>
                      <th>Cantidad</th>
                      <th># recibo</th>
                      <th>Fecha</th>
                      <th>Ver</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.payments &&
                      this.payments.response.data.map(
                        (payment: any, index: any) => {
                          return (
                            <tr key={index}>
                              <td>{payment.id}</td>
                              <td>{payment.type}</td>
                              <td>${payment.amount}</td>
                              <td>
                                {payment.invoice_id
                                  ? payment.invoice_id
                                  : "A favor"}
                              </td>
                              <td>{payment.created_date}</td>
                              <td className="td-actions">
                                <button
                                  type="button"
                                  title=""
                                  onClick={() => this.viewPayment(payment.id)}
                                  className="btn btn-primary btn-link btn-sm"
                                >
                                  <i className="material-icons">visibility</i>
                                  <div className="ripple-container"></div>
                                </button>
                              </td>
                            </tr>
                          );
                        }
                      )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="col-sm-6">
            <div className="card">
              <div className="card-header card-header-success card-header-icon">
                <div className="card-icon">
                  <i className="material-icons">perm_media</i>
                </div>
                <h3 className="card-title">Imagenes</h3>
              </div>
              <div className="card-body">
                <div className="col-sm-12">
                  <Photos
                    photos={this.photos}
                    loadPhotos={this.loadPhotos}
                    apiUrl={apiUrl}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-6">
            <div className="card">
              <div className="card-header card-header-success card-header-icon">
                <div className="card-icon">
                  <i className="material-icons">history</i>
                </div>
                <h3 className="card-title">Historial de edicion</h3>
              </div>
              <div className="card-body">
                <div className="col-sm-12">
                  <Link
                    to={`../../contratos/historia/${
                      this.contract.id != null && this.contract.id.toString().startsWith("W")
                        ? this.contract.id.substring(1)
                        : this.contract.id
                    }`}
                  >
                    <button className="btn btn-info btn-md">
                      Historial Contrato
                      <div className="ripple-container"></div>
                    </button>
                  </Link>
                  <br />
                  <EditionHistory
                    editionHistory={this.editionHistory}
                    loadHistory={this.loadHistory}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-sm-12">
            <div className="card">
              <div className="card-header card-header-info card-header-icon">
                <div className="card-icon">
                  <i className="material-icons">inventory_2</i>
                </div>
                <h3 className="card-title">Inventario</h3>
              </div>
              <div className="card-body table-responsive">
                <table className="table table-hover">
                  <thead className="text-warning">
                    <tr>
                      <th>ID</th>
                      <th>Nombre</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.inventory_items &&
                      this.inventory_items.map((inventory: any, index: any) => {
                        return (
                          <tr key={index}>
                            <td>{inventory.id}</td>
                            <td>{inventory.name}</td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }

  private viewInvoice = (id: any) => {
    history.push(`/recibos/ver/${id}`);
  };

  private viewPayment = (id: any) => {
    history.push(`/pagos/ver/${id}`);
  };

  private goSupport = (id: any) => {
    history.push(`/soporte/${id}`);
  };
}
